import appStoreBadge from './appStoreBadge.svg'
import googlePlayBadge from './googlePlayBadge.png'

/**
 * The stores' own badges, which is what their brand guidelines require — a
 * drawn lookalike is not allowed to ship. Both render at 40px tall: Apple's
 * SVG is 120x40, and Google's PNG is trimmed of the transparent margin it
 * ships with, so the two line up instead of one floating in its own padding.
 */
const STORES = [
  {
    name: 'Download on the App Store',
    src: appStoreBadge,
    href: 'https://apps.apple.com',
  },
  {
    name: 'Get it on Google Play',
    src: googlePlayBadge,
    href: 'https://play.google.com',
  },
]

/** FuelApp is an app, so the ask is a download rather than a sign-up. */
export function AppStoreBadges() {
  return (
    <div className="flex items-center gap-2">
      {STORES.map(({ name, src, href }) => (
        <a key={name} href={href} target="_blank" rel="noopener noreferrer">
          <img src={src} alt={name} className="h-10 w-auto" />
        </a>
      ))}
    </div>
  )
}
